import { faker } from "@faker-js/faker";

export interface IItemExample {
    id: number;
    skuTitle: string;
    fulfillmentCenter: string;
    fulfillmentStatus: string;
    createdBy: string;
    completedBy: string;
}

export default function mockItem(): IItemExample {
    return {
        id: faker.datatype.number(),
        skuTitle: faker.commerce.productName(),
        fulfillmentCenter: `${faker.address.cityName().slice(0, 3).toUpperCase()}${faker.helpers.arrayElement([
            "1",
            "2"
        ])}`,
        fulfillmentStatus: faker.helpers.arrayElement(["Open", "Completed", "Reviewed", "Cancelled", "Processing"]),
        createdBy: faker.date.past(1, "2023-08-01T00:00:00.000Z").toDateString(),
        completedBy: faker.date.past(1, "2023-08-01T00:00:00.000Z").toDateString()
    };
}
